import { request, getTokenManager } from '@/utils/http'

function resolveFileNameFromContentDisposition(contentDisposition: string | null): string | undefined {
  if (!contentDisposition) {
    return undefined
  }
  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]).trim()
    } catch {
      // ignore
    }
  }
  const normalMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
  if (normalMatch?.[1]) {
    return normalMatch[1].trim()
  }
  return undefined
}

/**
 * 上传 LCL 拼箱运价 Excel
 */
export const uploadLclExcel = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return request.post<string>('/mq/lcl/excel/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 确认导入 LCL 拼箱运价
 */
export const confirmLclImport = (batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/lcl/excel/confirm', null, {
    params: { batchNo, taskId }
  });

/**
 * 取消导入 LCL 拼箱运价
 */
export const cancelLclImport = (batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/lcl/excel/cancel', null, {
    params: { batchNo, taskId }
  });

/**
 * 下载 LCL 拼箱运价导入模板
 */
export const downloadLclExcelTemplate = () => {
  const fileId = import.meta.env.VITE_LCL_IMPORT_TEMPLATE_FILE_ID
  const token = getTokenManager().get()
  return fetch(`/gateway/universal/storage/findByFileId/${fileId}`, {
    method: 'GET',
    headers: token ? { Authorization: token } : undefined
  }).then(async res => {
    if (!res.ok) {
      throw new Error(`Download failed: ${res.status}`)
    }
    const blob = await res.blob()
    const fileName = resolveFileNameFromContentDisposition(res.headers.get('content-disposition')) || 'LCL_Rate_Template.xlsx'
    return {
      blob,
      fileName
    }
  })
}
